import React from 'react';
import * as SG from '../../constants/AppSettings';
import * as RT from '../../constants/Routing';
import { Link } from 'react-router-dom'

import {  bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { withRouter } from 'react-router-dom';
import * as Actions from '../../actions/Community';


class Component extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      "community[id]": "",
      "community[name]": "",
      "community[photo]": "",
      "community[category]": "",
      "community[area]": "",
      "community[price]": "",
      "community[member_limit]": "",
      "community[user_id]": props.currentUser ? props.currentUser.id : "",
      "community[title1]": "",
      "community[title2]": "",
      "community[title3]": "",
      "community[body1]": "",
      "community[body2]": "",
      "community[body3]": "",
      "community[description]": "",
      "community[published]": false,
      "community[approval]": "false",
      toPreview: false
    };
  };

  fetchCircle = (props) => {
    console.log('fetchCircle', this.state, this.props)
    let description, descriptionHash, newState
    description = props.circle ? props.circle.description : ""
    descriptionHash = this.parseDescription(description)

    if (this.props.Community.previewCommunity) {
      const previewCommunity = this.props.Community.previewCommunity

      description = previewCommunity.description
      descriptionHash = this.parseDescription(description)

      newState = {
        "community[id]": previewCommunity.id,
        "community[name]": previewCommunity.name,
        "community[photo]": previewCommunity.photo,
        "community[category]": previewCommunity.category,
        "community[area]": previewCommunity.area,
        "community[price]": previewCommunity.price,
        "community[member_limit]": previewCommunity.member_limit,
        "community[user_id]": props.currentUser ? props.currentUser.id : "",
        "community[title1]": descriptionHash["community[title1]"] || "",
        "community[title2]": descriptionHash["community[title2]"] || "",
        "community[title3]": descriptionHash["community[title3]"] || "",
        "community[body1]": descriptionHash["community[body1]"] || "",
        "community[body2]": descriptionHash["community[body2]"] || "",
        "community[body3]": descriptionHash["community[body3]"] || "",
        "community[description]": description || "",
        "community[published]": props.circle ? props.circle.published : false,
        "community[approval]": props.circle ? !!props.circle.approval ? "true" : "false" : "false"
      }
    } else {
      newState = {
        "community[id]": props.circle ? props.circle.id : "",
        "community[name]": props.circle ? props.circle.name : "",
        "community[photo]": props.circle ? props.circle.photo : "",
        "community[category]": props.circle ? props.circle.category : "",
        "community[area]": props.circle ? props.circle.area : "",
        "community[price]": props.circle ? props.circle.price : "",
        "community[member_limit]": props.circle ? props.circle.member_limit : "",
        "community[user_id]": props.currentUser ? props.currentUser.id : "",
        "community[title1]": descriptionHash["community[title1]"] || "",
        "community[title2]": descriptionHash["community[title2]"] || "",
        "community[title3]": descriptionHash["community[title3]"] || "",
        "community[body1]": descriptionHash["community[body1]"] || "",
        "community[body2]": descriptionHash["community[body2]"] || "",
        "community[body3]": descriptionHash["community[body3]"] || "",
        "community[description]": description || "",
        "community[published]": props.circle ? props.circle.published : false,
        "community[approval]": props.circle ? !!props.circle.approval ? "true" : "false" : "false"
      }
    }
    this.setState(newState)
  }

  checkAllEnter = () => {
    // 全入力チェック
    if (!!this.state['community[name]'] &&
      !!this.state['community[photo]'] &&
      !!this.state['community[category]'] &&
      !!this.state['community[area]'] &&
      this.state['community[price]'] !== undefined && 
      this.state['community[price]'] !== null &&
      this.state['community[member_limit]'] >= 0 && 
      this.state['community[member_limit]'] !== 1 &&
      !!this.state['community[title1]'] && 
      !!this.state['community[body1]'] && 
      !!this.state['community[user_id]'] && 
      !!this.state['community[approval]'] ) {
      return true
    } else {
      return false
    }
  }

  onSubmit = (e) => {
    e.preventDefault();

    // this.fetchCircle(this.props)
    const form = document.querySelector('.community-form')
    if (!document.querySelector('.community-photo-input').files.length) document.querySelector('.community-photo-input').setAttribute('disabled', '')


    const formData = new FormData(form)
    document.querySelector('.community-photo-input').removeAttribute('disabled')

    if (this.props.method === 'update') {
      // console.log('ID', this.state, this.state["community[id]"])
      this.props.communityPreviewDelete()
      this.props.communitySave(formData, this.state["community[id]"], false, !this.props.circle.published)
    } else {
      this.props.communitySave(formData)
    }
    
  }

  toPreview = (e) => {
    e.preventDefault();

    this.fetchCircle(this.props)
    const form = document.querySelector('.community-form')
    if (!document.querySelector('.community-photo-input').files.length) document.querySelector('.community-photo-input').setAttribute('disabled', '')

    const formData = new FormData(form)
    // console.log('to preview', formData)
    document.querySelector('.community-photo-input').removeAttribute('disabled')
    
    if (this.props.method === 'update') {

      const previewCommunity = Object.assign({}, this.props.Community.community, {
        id: this.state["community[id]"],
        name: this.state["community[name]"],
        photo: this.state["community[photo]"],
        category: this.state["community[category]"],
        area: this.state["community[area]"],
        price: this.state["community[price]"],
        member_limit: this.state["community[member_limit]"],
        user_id: this.state["community[user_id]"],
        description: this.state["community[description]"],
        published: this.state["community[published]"],
        approval: this.state["community[approval]"],
        status: this.state["community[published]"] ? 'published' : 'draft',
      })


      const fileInput = document.querySelector('.community-photo-input')
      const formData = new FormData();
      formData.append("community[name]", this.state["community[name]"])
      formData.append("community[category]", this.state["community[category]"])
      formData.append("community[member_limit]", this.state["community[member_limit]"])
      formData.append("community[description]", this.state["community[description]"])
      formData.append("community[approval]", this.state["community[approval]"])
      formData.append("community[status]", previewCommunity.status)
      formData.append("community[price]", this.props.Community.community.price)

      if (this.props.Community.community.photo !== previewCommunity.photo) {
        const fileList = fileInput.files;
        // Blob URLの作成
        const blobUrl = window.URL.createObjectURL(fileList[0]);
        previewCommunity.photo = blobUrl

        formData.append("community[photo]", fileInput.files[0])
      }

      this.setState({toPreview: true}, () => {
        this.props.communityPreviewSet(previewCommunity, formData)
      })

    } else {
      this.setState({toPreview: true}, () => {
        this.props.communitySave(formData, true)
      })
    }

  }

  parseDescription = (desc) => {
    if (!!desc) {
      let title1, title1_reg, title2, title2_reg, title3, title3_reg, body1, body1_reg, body2, body2_reg, body3, body3_reg, reg

      reg = new RegExp(SG.COMMUNITY_TITLE1_MARK_REG + '[\\s\\S]*' + SG.COMMUNITY_TITLE1_MARK_REG)
      title1_reg = desc.match(reg)
      title1 = !!title1_reg ? title1_reg[0].replace(SG.COMMUNITY_TITLE1_MARK, '').replace(SG.COMMUNITY_TITLE1_MARK, '') : ''

      reg = new RegExp(SG.COMMUNITY_TITLE2_MARK_REG + '[\\s\\S]*' + SG.COMMUNITY_TITLE2_MARK_REG)
      title2_reg = desc.match(reg)
      title2 = !!title2_reg ? title2_reg[0].replace(SG.COMMUNITY_TITLE2_MARK, '').replace(SG.COMMUNITY_TITLE2_MARK, '') : ''

      reg = new RegExp(SG.COMMUNITY_TITLE3_MARK_REG + '[\\s\\S]*' + SG.COMMUNITY_TITLE3_MARK_REG)
      title3_reg = desc.match(reg)
      title3 = !!title3_reg ? title3_reg[0].replace(SG.COMMUNITY_TITLE3_MARK, '').replace(SG.COMMUNITY_TITLE3_MARK, '') : ''

      reg = new RegExp(SG.COMMUNITY_BODY1_MARK_REG + '[\\s\\S]*' + SG.COMMUNITY_BODY1_MARK_REG)
      body1_reg = desc.match(reg)
      body1 = !!body1_reg ? body1_reg[0].replace(SG.COMMUNITY_BODY1_MARK, '').replace(SG.COMMUNITY_BODY1_MARK, '') : ''

      reg = new RegExp(SG.COMMUNITY_BODY2_MARK_REG + '[\\s\\S]*' + SG.COMMUNITY_BODY2_MARK_REG)
      body2_reg = desc.match(reg)
      body2 = !!body2_reg ? body2_reg[0].replace(SG.COMMUNITY_BODY2_MARK, '').replace(SG.COMMUNITY_BODY2_MARK, '') : ''

      reg = new RegExp(SG.COMMUNITY_BODY3_MARK_REG + '[\\s\\S]*' + SG.COMMUNITY_BODY3_MARK_REG)
      body3_reg = desc.match(reg)
      body3 = !!body3_reg ? body3_reg[0].replace(SG.COMMUNITY_BODY3_MARK, '').replace(SG.COMMUNITY_BODY3_MARK, '') : ''
      
      const reg_descriptions = {
        "community[title1]": title1 || "",
        "community[title2]": title2 || "",
        "community[title3]": title3 || "",
        "community[body1]": body1 || "",
        "community[body2]": body2 || "",
        "community[body3]": body3 || ""
      }
      return reg_descriptions
    } else {
      return {
        "community[title1]": "",
        "community[title2]": "",
        "community[title3]": "",
        "community[body1]": "",
        "community[body2]": "",
        "community[body3]": ""
      }
    }
  }

  joinFormData = () => {
    const body1 = document.getElementsByName("community[body1]")[0].value
    const body2 = document.getElementsByName("community[body2]")[0].value
    const body3 = document.getElementsByName("community[body3]")[0].value
    const title1 = document.getElementsByName("community[title1]")[0].value
    const title2 = document.getElementsByName("community[title2]")[0].value
    const title3 = document.getElementsByName("community[title3]")[0].value

    const params = `${SG.COMMUNITY_TITLE1_MARK}${title1}${SG.COMMUNITY_TITLE1_MARK}${SG.COMMUNITY_TITLE2_MARK}${title2}${SG.COMMUNITY_TITLE2_MARK}${SG.COMMUNITY_TITLE3_MARK}${title3}${SG.COMMUNITY_TITLE3_MARK}${SG.COMMUNITY_BODY1_MARK}${body1}${SG.COMMUNITY_BODY1_MARK}${SG.COMMUNITY_BODY2_MARK}${body2}${SG.COMMUNITY_BODY2_MARK}${SG.COMMUNITY_BODY3_MARK}${body3}${SG.COMMUNITY_BODY3_MARK}`

    return params
  }

  valueChange = (e) => {
    if (e.target.name === "community[photo]") {
      const filePreviewBox = document.getElementById('img-prev-area')
      const fileInput = e.target
      const previewImage = document.querySelector('.preview-image')
      const file = fileInput.files[0]

      const isValidFile = !!file ? this.validateFileExtensions(file) : false

      if (!fileInput.files.length || !isValidFile) {

        if (!!this.props.circle && !!this.props.circle.photo) {

          previewImage.src = `${this.props.circle.photo}`
        } else {
          filePreviewBox.classList.remove('previewed')
          previewImage.classList.add('d-none')
          previewImage.src = ''
        }

        e.target.value = ''

      } else {

        filePreviewBox.classList.add('previewed')

        let fileReader = new FileReader();

        fileReader.onload = () => {
          // filePreviewBox.style.backgroundImage = `url(${fileReader.result})`
          previewImage.src = fileReader.result
          previewImage.classList.remove('d-none')
        }
        fileReader.readAsDataURL(fileInput.files[0])
        fileReader.onload()
      }

    }

    const params = this.joinFormData();
    this.setState({
      "community[description]": params,
      [e.target.name]: e.target.value
    })
  }

  validateFileExtensions = (file) => {
    var validFileExtensions = ["jpg", "jpeg", "gif", "png"];
    var fileErrors = new Array();

    var ext = file.name.split('.').pop();

    if (validFileExtensions.indexOf(ext) === -1) {
      fileErrors.push('画像は jpg, jpeg, gif, png のいずれかのフォーマットのものを選択する必要があります。')
    }

    if (file.size >= SG.FILE_SIZE_LIMIT) {
      const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB'];
      let ext = sizes[0];
      let size = SG.FILE_SIZE_LIMIT

      if (typeof size === 'number') {
        for (var i = 1; i < sizes.length; i += 1) {
          if (size >= 1024) {
            size = size / 1024;
            ext = sizes[i];
          }
        }
      }

      const limit = this.round(size, 2) + ext;

      fileErrors.push(`ファイルの容量が大きすぎます。 ${limit} 以下のサイズのファイルを選択して下さい。`)
    }

    if (fileErrors.length > 0) {
      this.props.noticeInCommunity(fileErrors, 'error')
      return false;
    }
    return true;
  }

  round = (value, precision, mode) => {

    var m, f, isHalf, sgn; // helper variables
    precision |= 0; // making sure precision is integer
    m = Math.pow(10, precision);
    value *= m;
    sgn = (value > 0) | -(value < 0); // sign of the number
    isHalf = value % 1 === 0.5 * sgn;
    f = Math.floor(value);

    if (isHalf) {
      switch (mode) {
        case 'PHP_ROUND_HALF_DOWN':
          value = f + (sgn < 0); // rounds .5 toward zero
          break;
        case 'PHP_ROUND_HALF_EVEN':
          value = f + (f % 2 * sgn); // rouds .5 towards the next even integer
          break;
        case 'PHP_ROUND_HALF_ODD':
          value = f + !(f % 2); // rounds .5 towards the next odd integer
          break;
        default:
          value = f + (sgn > 0); // rounds .5 away from zero
      }
    }

    return (isHalf ? value : Math.round(value)) / m;

  }


  componentWillReceiveProps = (nextProps) => {
    if (this.props.circle !== nextProps.circle) {
      this.fetchCircle(nextProps)
    }
    
  }

  componentWillUnmount = () => {
    if (!this.state.toPreview) {
      this.props.communityPreviewDelete()
    }
  }

  componentDidUpdate = () => {

    let locationPreview = false
    
    if (this.props.Location.previousLocation) {
      locationPreview = !!this.props.Location.previousLocation.match(/community\/\d\/preview/)
    }

    if (this.props.Community.previewMode) {
      const { history } = this.props
      history.push(RT.COMMUNITY_PREVIEW_PATH.replace(/:id/, this.props.Community.previewCommunity.id))

    }
  }


  fileInputClick = () => {
    const fileInput = document.querySelector('.community-photo-input')
    fileInput.click()
  }

  render = () => {

    const catSelect = SG.categories.map((cat) => {
      return (
        <option key={cat.id} value={cat.name}>{cat.name}</option>
      )
    })

    const areaSelect = SG.places.map((place) => {
      return (
        <option key={place.id} value={place.name}>{place.name}</option>
      )
    })

    const photo = !!this.state['community[photo]'] ? this.state['community[photo]'] : (!!this.props.circle && !!this.props.circle.photo) ? this.props.circle.photo : ''
    const photoClass = (!!photo) ? 'previewed' : ''

    let memberLimitMsg
    if (this.state["community[member_limit]"] === 1) {
      memberLimitMsg = (
        <span className='error-message'>人数制限を設ける場合は2人以上に設定してください</span>
      )
    } else {
      memberLimitMsg = (
        <span className='help-message'>制限なしの場合は【 0 】を入力してください</span>
      )
    }

    let actionBtns
    if (this.state["community[published]"]) {

      actionBtns = (
        <div className='row'>
          <div className='mb15 col-6 col-sm-4'>
            <Link to={RT.COMMUNITY_MANAGE_PATH.replace(/:id/, this.props.circle.id)} className='btn btn-default btn-bordered btn-block'>サークル管理ページへ</Link>
          </div>
          {(() => {
            if (this.checkAllEnter()) {
              return (
                <div className='mb15 col-6 col-sm-4'>
                  <input type='submit' value='プレビュー' className='btn btn-primary btn-bordered' onClick={this.toPreview}/>
                </div>
              )
            } else {
              return (
                <div className='mb15 col-6 col-sm-4'>
                  <input type='submit' value='プレビュー' className='btn btn-primary btn-bordered' disabled />
                </div>
              )
            }
          })()}
        </div>
      )
    } else {
      actionBtns = (
        <div className='row'>
          <div className='mb15 col-6 col-sm-4'>
            <input type='submit' value='下書き保存' className='btn btn-white btn-bordered' />
          </div>
          {(() => {
            if (this.checkAllEnter()) {
              return (
                <div className='mb15 col-6 col-sm-4'>
                  <input type='submit' value='プレビュー' className='btn btn-primary btn-bordered' onClick={this.toPreview}/>
                </div>
              )
            } else {
              return (
                <div className='mb15 col-6 col-sm-4'>
                  <input type='submit' value='プレビュー' className='btn btn-primary btn-bordered' disabled />
                </div>
              )
            }
          })()}
          {(() => {
            if (this.props.circle && this.props.circle.id) {
              return (
                <div className='mb15 col-12 col-sm-4'>
                  <Link to={RT.COMMUNITY_MANAGE_PATH.replace(/:id/, this.props.circle.id)} className='btn btn-default btn-bordered btn-block'>サークル管理ページへ</Link>
                </div>
              )
            } else {
              return (
                <div className='mb15 col-12 col-sm-4'>
                  <Link to={RT.USER_MYPAGE_PATH} className='btn btn-default btn-bordered btn-block'>マイページに戻る</Link>
                </div>
              )
            }
          })()}

        </div>
      )
    }

    return (
      <form className='community-form form' onSubmit={this.onSubmit} >
        <h2 className='headline'>{this.props.title ? this.props.title : 'コミュニティー フォーム'}</h2>

        <div className='row'>
          <div className='field col-12'>
            <label htmlFor='community[name]' className="need-icon d-block">サークル名</label>
            <input type='text' name='community[name]' value={this.state["community[name]"]} onChange={this.valueChange} />
          </div>
          
          <div className='field col-12 col-lg-5 col-xl-4'>
            <label htmlFor="community[photo]" className="need-icon d-block">メイン画像</label>
            <div id='img-prev-area' className={photoClass} onClick={this.fileInputClick}>
              <input type='file' accept=".jpg,.gif,.png,image/gif,image/jpeg,image/png" name='community[photo]' onChange={this.valueChange} className='community-photo-input d-none' />
              <img src={photo} alt='' className='preview-image' />
            </div>
          </div>

          <div className='col-12 col-lg-7 col-xl-8'>
            <div className='row'>
              <div className='field col-6 col-sm-6 col-lg-6'>
                <label htmlFor='community[category]' className="need-icon d-block">カテゴリー</label>
                <select name="community[category]" id="category" onChange={this.valueChange} value={this.state["community[category]"]} >
                  <option value=''></option>
                  { catSelect }
                </select>
              </div>

              <div className='field col-6 col-sm-6 col-lg-6'>
                <label htmlFor='community[area]' className="need-icon d-block">エリア</label>
                <select name="community[area]" id="area" onChange={this.valueChange} value={this.state["community[area]"]} >
                  <option value=''></option>
                  { areaSelect }
                </select>
              </div>

              <div className='field col-6 col-sm-6 col-lg-6'>
                <label htmlFor='community[price]' className="need-icon d-block">参加費用(税込)</label>
                {(() => {
                  if (this.state["community[published]"]) {
                    return (
                      <input type='number' min='0' name='community[price]' value={this.state["community[price]"]} className='readonly' readOnly={true} />
                    )
                  } else {
                    return (
                      <input type='number' min='0' name='community[price]' onChange={this.valueChange} value={this.state["community[price]"]} />
                    )
                  }
                })()}
              </div>

              <div className={'field col-6 col-sm-6 col-lg-6' + (this.state["community[member_limit]"] === 1 ? ' with_error' : '')}>
                <label htmlFor='community[member_limit]' className="need-icon d-block">人数制限(人)</label>
                <input type='number' min='0' name='community[member_limit]' onChange={this.valueChange} value={this.state["community[member_limit]"]}/>
                {memberLimitMsg}
              </div>
            </div>
          </div>
          {/* <div className='field col-12'>
            <label htmlFor='community[host]' className="need-icon">管理人</label>
            <input type='text' name='community[host]' onChange={this.valueChange} />
          </div> */}

          <div className='field col-12'>
            <label htmlFor='community[title1]' className="need-icon d-block">タイトル1</label>
            <input type='text' name='community[title1]' value={this.state["community[title1]"]} onChange={this.valueChange}/>
          </div>
          <div className='field col-12'>
            <label htmlFor='community[body1]' className="need-icon d-block">本文1</label>
            <textarea type='text' name='community[body1]' onChange={this.valueChange} value={this.state["community[body1]"]} ></textarea>
          </div>
          <div className='field col-12'>
            <label htmlFor='community[title2]' className="noneed-icon d-block">タイトル2</label>
            <input type='text' name='community[title2]' value={this.state["community[title2]"]} onChange={this.valueChange} />
          </div>
          <div className='field col-12'>
            <label htmlFor='community[body2]' className="noneed-icon d-block">本文2</label>
            <textarea type='text' name='community[body2]' onChange={this.valueChange} value={this.state["community[body2]"]}></textarea>
          </div>
          <div className='field col-12'>
            <label htmlFor='community[title3]' className="noneed-icon d-block">タイトル3</label>
            <input type='text' name='community[title3]' value={this.state["community[title3]"]} onChange={this.valueChange} />
          </div>
          <div className='field col-12'>
            <label htmlFor='community[body3]' className="noneed-icon d-block">本文3</label>
            <textarea type='text' name='community[body3]' onChange={this.valueChange} value={this.state["community[body3]"]}></textarea>
          </div>

          <div className='field col-12 text-left'>
            <label htmlFor="community[approval]" className='need-icon d-block'>参加申請タイプ</label>
            <div className='radio-wrap'>
              <input type="radio" name="community[approval]" value="true" id="approve" checked={this.state["community[approval]"] === "true"} onChange={this.valueChange} />
              <label htmlFor="approve">承認制</label>
            </div>
            <div className='radio-wrap'>
              <input type="radio" name="community[approval]" value="false" id="free" checked={this.state["community[approval]"] === "false"} onChange={this.valueChange} />
              <label htmlFor="free">自由参加制</label>
            </div>
          </div>

          <input type="hidden" name="community[description]" value={this.state["community[description]"]} />

          <div className='col-12'>
            {actionBtns}
          </div>

        </div>

      </form>
    )
  }
}


const mapStateToProps = (state) => {
  return state
};

const mapDispatchToProps = (dispatch) => (bindActionCreators(Actions, dispatch));


const Container = connect(
  mapStateToProps,
  mapDispatchToProps,
)(Component);

export default withRouter(Container);


// WEBPACK FOOTER //
// ./src/components/Community/Form.js